var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChademoSocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_19552)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M72.0313 44.8796C76.6622 25.2587 64.5105 5.59876 44.8896 0.967807C25.2687 -3.66314 5.60874 8.4886 0.977787 28.1095C-3.65316 47.7304 8.49858 67.3904 28.1195 72.0213C47.7403 76.6523 67.4003 64.5005 72.0313 44.8796Z",
    fill: "#172228"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02122 42.5159C8.02122 26.944 20.6498 14.3154 36.2217 14.3154C51.7937 14.3154 64.4222 26.944 64.4222 42.5159C64.4222 43.5946 64.3534 44.6561 64.2386 45.7003C65.4722 42.4069 66.155 38.8381 66.155 35.1086C66.155 18.5211 52.7978 5.07208 36.3193 5.07208C19.8408 5.07208 6.4778 18.5211 6.4778 35.1086C6.4778 38.5684 7.06304 41.8848 8.13598 44.9774C8.06712 44.1684 8.02122 43.3479 8.02122 42.5159Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.4111 64.6517C20.0416 64.6517 6.71878 51.2428 6.71878 34.7643C6.71878 18.2858 20.0358 4.87695 36.4111 4.87695C52.7863 4.87695 66.1034 18.2858 66.1034 34.7643C66.1034 51.2428 52.7863 64.6517 36.4111 64.6517ZM36.4111 5.27285C20.2596 5.27285 7.12042 18.5038 7.12042 34.7643C7.12042 51.0248 20.2596 64.2558 36.4111 64.2558C52.5625 64.2558 65.7075 51.0248 65.7075 34.7643C65.7075 18.5038 52.5625 5.27285 36.4111 5.27285Z",
    fill: "#88D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4111 64.8009C52.8889 64.8009 66.2468 51.3531 66.2468 34.7643C66.2468 18.1756 52.8889 4.72778 36.4111 4.72778C19.9332 4.72778 6.57533 18.1756 6.57533 34.7643C6.57533 51.3531 19.9332 64.8009 36.4111 64.8009Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4111 64.8009C52.8889 64.8009 66.2468 51.3531 66.2468 34.7643C66.2468 18.1756 52.8889 4.72778 36.4111 4.72778C19.9332 4.72778 6.57533 18.1756 6.57533 34.7643C6.57533 51.3531 19.9332 64.8009 36.4111 64.8009Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9333 0.952394C29.9849 0.946657 30.0365 0.935181 30.0939 0.923706C30.0251 0.935181 29.9333 0.946657 29.9333 0.952394Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0882 0.923707C30.1226 0.917969 30.157 0.912231 30.157 0.912231C30.1341 0.912231 30.1111 0.923707 30.0882 0.923707Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5256 7.50481C57.5256 7.50481 57.5084 7.54497 57.5026 7.56792C53.9912 4.84254 49.9404 2.77699 45.5167 1.56635C45.3962 1.52619 45.2815 1.50324 45.161 1.46881C44.9716 1.41717 44.788 1.37127 44.5987 1.32537C44.352 1.26799 44.0995 1.21062 43.8528 1.15324C43.6749 1.11308 43.5028 1.06718 43.3307 1.03275C43.3307 1.03275 43.3307 1.03849 43.3307 1.04423C38.8553 0.143417 34.3054 0.154892 29.9333 1.0098V0.952424C14.5621 3.89583 2.67374 17.0981 2.04834 33.4045C1.40572 50.0494 12.7031 64.382 28.2923 68.1574C43.1987 71.8524 59.2698 65.1681 66.8607 51.0133C74.9336 35.9578 70.6476 17.5801 57.5256 7.50481ZM43.1872 5.87532C56.7395 9.03676 66.5968 21.4473 66.0402 35.8717C65.4091 52.2297 51.6388 64.9788 35.2808 64.3476C33.2726 64.273 31.316 63.9919 29.4341 63.5386C27.0874 62.9591 24.7751 62.0755 22.5432 60.8821C8.11302 53.1477 2.68522 35.1774 10.4253 20.753C16.8801 8.70397 30.4726 2.94339 43.1815 5.87532H43.1872Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6716 1.60077C45.706 1.61224 45.7347 1.61798 45.7347 1.61798C45.7118 1.61224 45.6888 1.60651 45.6716 1.60077Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5167 1.55487C45.5683 1.57208 45.62 1.58356 45.6716 1.60077C45.6085 1.58356 45.5167 1.55487 45.5167 1.55487Z",
    fill: "#31404C"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.47127 42.8143C-0.533603 27.4718 6.71878 10.5458 21.2121 3.70076C25.8481 1.46308 30.9947 0.258172 36.1299 0.372925C31.0865 0.77456 26.0948 2.14012 21.6366 4.53271C7.7286 11.7621 0.860644 27.5808 3.47127 42.8143Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4962 2.77698C71.1066 10.6605 78.2614 41.1331 60.5837 58.6788C58.2657 60.9566 55.6551 62.9361 52.7978 64.4509C58.2084 61.0026 62.7124 56.16 65.5927 50.4396C74.8533 32.4348 66.0861 10.3564 47.4904 2.77698H47.4962Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2988 37.3864C38.2988 30.0939 44.2085 24.1841 51.5068 24.1841C58.8051 24.1841 64.7091 30.0939 64.7091 37.3864C64.7091 44.6789 58.7993 50.5944 51.5068 50.5944C44.2143 50.5944 38.2988 44.6847 38.2988 37.3864Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9628 17.3219C25.9628 11.7047 30.5185 7.14905 36.1357 7.14905C41.7528 7.14905 46.3085 11.7047 46.3085 17.3219C46.3085 22.939 41.7528 27.4947 36.1357 27.4947C30.5185 27.4947 25.9628 22.939 25.9628 17.3219Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8481 53.951C25.8481 48.3338 30.4038 43.7781 36.0209 43.7781C41.6381 43.7781 46.1937 48.3338 46.1937 53.951C46.1937 59.5681 41.6381 64.1238 36.0209 64.1238C30.4038 64.1238 25.8481 59.5681 25.8481 53.951Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.9504 40.6855C66.3741 35.1463 64.6592 27.8804 59.12 24.4566C53.5808 21.0328 46.3149 22.7478 42.8911 28.287C39.4674 33.8262 41.1823 41.0921 46.7215 44.5158C52.2607 47.9396 59.5266 46.2247 62.9504 40.6855Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2439 37.3865C32.607 30.0251 27.2538 24.0005 19.858 24.0005C12.4622 24.0005 6.47206 29.9906 6.47206 37.3865C6.47206 44.7823 12.8466 49.5044 20.2367 49.5044C29.4054 49.5044 33.5996 41.5864 33.2382 37.3865H33.2439Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.13024 35.6881C7.39008 28.2292 13.6097 22.0096 21.0686 22.7497C26.5882 23.2948 31.0521 27.7587 31.5972 33.2783C32.3373 40.7372 26.1177 46.9569 18.6588 46.2167C13.1392 45.6716 8.67531 41.2077 8.13024 35.6881Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9546 34.7644C23.9546 37.1684 22.1243 39.1192 19.8637 39.1192C17.6031 39.1192 15.7728 37.1684 15.7728 34.7644C15.7728 32.3603 17.6031 30.4095 19.8637 30.4095C22.1243 30.4095 23.9546 32.3603 23.9546 34.7644Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.1744 35.1029C15.7556 32.5439 17.9359 30.3636 20.4949 30.7824C22.044 31.0349 23.2948 32.2857 23.5473 33.8349C23.9661 36.3939 21.7858 38.5742 19.2268 38.1553C17.6777 37.9029 16.4269 36.652 16.1744 35.1029Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8629 35.0685C16.4556 32.9168 18.3088 31.0636 20.4604 31.471C21.6653 31.7005 22.635 32.6701 22.8588 33.8693C23.2661 36.0209 21.4129 37.8742 19.2613 37.4668C18.0564 37.2373 17.0867 36.2676 16.8629 35.0685Z",
    fill: "url(#paint0_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2387 34.7644C57.2387 37.1684 55.4084 39.1192 53.1478 39.1192C50.8871 39.1192 49.0568 37.1684 49.0568 34.7644C49.0568 32.3603 50.8871 30.4095 53.1478 30.4095C55.4084 30.4095 57.2387 32.3603 57.2387 34.7644Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M49.4585 35.1029C49.0396 32.5439 51.2199 30.3636 53.7789 30.7824C55.3281 31.0349 56.5789 32.2857 56.8313 33.8349C57.2502 36.3939 55.0699 38.5742 52.5109 38.1553C50.9617 37.9029 49.7109 36.652 49.4585 35.1029Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.147 35.0685C49.7396 32.9168 51.5929 31.0636 53.7445 31.471C54.9494 31.7005 55.919 32.6701 56.1428 33.8693C56.5502 36.0209 54.6969 37.8742 52.5453 37.4668C51.3404 37.2373 50.3707 36.2676 50.147 35.0685Z",
    fill: "url(#paint1_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4933 45.1036C5.5024 40.1979 5.43355 28.1833 14.5334 23.5759C17.276 22.1702 20.3858 22.3424 23.3579 23.1227C20.3629 22.5432 17.1613 22.4342 14.5162 23.8743C5.75485 28.5964 6.0819 39.8594 14.499 45.0978L14.4933 45.1036Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.6469 25.8939C66.2009 30.5816 65.696 39.7733 59.6944 43.8585C57.8182 45.1552 55.6838 46.2683 53.4002 46.274C55.6609 46.0904 57.7207 44.9257 59.5108 43.6003C65.2485 39.452 65.6845 30.7881 60.6411 25.8939H60.6469Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6439 25.8939C33.198 30.5816 32.6931 39.7733 26.6915 43.8585C24.8153 45.1552 22.6809 46.2683 20.3973 46.274C22.6579 46.0904 24.7178 44.9257 26.5079 43.6003C32.2455 39.452 32.6816 30.7881 27.6382 25.8939H27.6439Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.4563 16.4383C26.4563 10.9589 30.8972 6.51221 36.3824 6.51221C41.8676 6.51221 46.3085 10.9531 46.3085 16.4383C46.3085 21.9235 41.8676 26.3644 36.3824 26.3644C30.8972 26.3644 26.4563 21.9235 26.4563 16.4383Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6325 16.4383C27.6325 11.6072 31.5455 7.69415 36.3766 7.69415C41.2077 7.69415 45.1208 11.6072 45.1208 16.4383C45.1208 21.2694 41.2077 25.1825 36.3766 25.1825C31.5455 25.1825 27.6325 21.2694 27.6325 16.4383Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.5668 22.6694C39.5668 24.2644 38.2471 25.848 36.6807 25.5554C30.3865 24.3792 34.0758 25.9685 33.7947 22.6694C33.657 21.08 35.0857 19.7833 36.6807 19.7833C38.2758 19.7833 39.5668 21.0743 39.5668 22.6694Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1093 15.6809C44.7421 11.2917 41.1274 7.83186 36.6693 7.69989C36.6234 7.69989 36.5832 7.68842 36.543 7.68842C36.5258 7.68842 36.5143 7.68842 36.5029 7.68842C36.4742 7.68842 36.4455 7.68842 36.4168 7.68842C32.0562 7.68842 28.4931 10.6835 27.8103 15.0096C27.4317 15.4457 27.1792 15.9908 27.1161 16.6047C27.0358 17.3908 27.2825 18.1309 27.7415 18.7047C27.8735 19.6629 28.2579 20.0875 29.3136 21.5907C29.1816 20.9653 29.1185 20.3112 29.1243 19.6571C29.3079 19.7145 29.4972 19.7547 29.698 19.7719C31.2873 19.9325 32.6988 18.7735 32.8595 17.1899C33.0086 15.7383 32.0447 14.4416 30.6619 14.1031C31.448 12.7146 32.4865 11.5384 33.6685 10.7982C33.7832 12.29 35.0168 13.4662 36.5373 13.4662C38.1324 13.4662 39.4233 12.1753 39.4233 10.5802C39.4233 10.5458 39.4118 10.5171 39.4118 10.4826C41.3397 11.1826 42.9462 12.5425 43.9733 14.2867C43.52 13.9941 42.9864 13.822 42.4126 13.822C40.8176 13.822 39.5266 15.1129 39.5266 16.708C39.5266 18.3031 40.8176 19.594 42.4126 19.594C44.0077 19.594 45.2987 18.3031 45.2987 16.708C45.2987 16.3465 45.2241 16.0023 45.1036 15.6809H45.1093Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.6676 6.59251C31.1783 5.77203 25.7161 11.2343 26.5366 17.7235C27.0931 22.1473 30.6677 25.7161 35.0857 26.2784C41.5749 27.0988 47.0372 21.6366 46.2167 15.1473C45.6601 10.7236 42.0856 7.1548 37.6619 6.59251H37.6676ZM39.32 23.3694C39.4463 22.9792 39.4864 22.5546 39.4119 22.1071C39.2397 21.0055 38.3619 20.0932 37.266 19.8924C35.4471 19.5538 33.875 21.0284 34.0529 22.8243C34.0816 23.1399 34.1734 23.4382 34.2996 23.7079C34.575 24.2759 33.9955 24.8726 33.4045 24.6546C31.1841 23.8513 29.3767 22.1759 28.4071 20.0415C28.1431 19.462 28.6997 18.8596 29.2964 19.0776C29.8759 19.2899 30.5415 19.3129 31.2242 19.0489C31.907 18.7907 32.4636 18.2399 32.7275 17.5571C33.4332 15.7613 32.1824 14.0113 30.5013 13.8449C30.048 13.799 29.612 13.8678 29.2218 14.0228C28.6423 14.258 28.0341 13.7129 28.2694 13.1334C29.1931 10.8671 31.0349 9.08265 33.3357 8.22774C33.9037 8.01544 34.4832 8.60642 34.2365 9.15723C34.0299 9.61051 33.9496 10.1269 34.0299 10.672C34.1906 11.7851 35.0742 12.7146 36.1816 12.9211C38.0004 13.2654 39.5725 11.7851 39.3946 9.98919C39.3774 9.79985 39.3373 9.61051 39.2799 9.43264C39.0905 8.84166 39.7274 8.32528 40.284 8.60642C42.1028 9.51871 43.5544 11.0392 44.3749 12.9039C44.6274 13.4777 44.0593 14.1088 43.4798 13.8621C42.8716 13.5982 42.143 13.558 41.4085 13.8391C40.7258 14.1031 40.175 14.6539 39.911 15.3367C39.211 17.1268 40.4618 18.8711 42.143 19.0375C43.7438 19.1981 45.0921 17.9588 45.1208 16.3981C45.1208 16.4039 45.1208 16.4096 45.1208 16.4211C45.1208 19.835 43.1643 22.7841 40.3069 24.2243C39.7332 24.5112 39.125 23.9661 39.32 23.3579V23.3694Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7062 16.6104C31.7062 17.4711 31.0464 18.1711 30.2374 18.1711C29.4284 18.1711 28.7685 17.4711 28.7685 16.6104C28.7685 15.7498 29.4284 15.0498 30.2374 15.0498C31.0464 15.0498 31.7062 15.7498 31.7062 16.6104Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.912 16.7309C28.7628 15.8129 29.5431 15.0326 30.4611 15.1818C31.0177 15.2736 31.4652 15.7211 31.557 16.2777C31.7062 17.1957 30.9259 17.976 30.0079 17.8268C29.4513 17.735 29.0038 17.2875 28.912 16.7309Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1587 16.7195C29.0095 15.9449 29.6751 15.285 30.4497 15.4285C30.88 15.5088 31.23 15.8588 31.3103 16.2891C31.4595 17.0637 30.7939 17.7235 30.0193 17.5801C29.589 17.4998 29.239 17.1498 29.1587 16.7195Z",
    fill: "url(#paint2_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2127 10.4941C38.2127 11.3548 37.5529 12.0547 36.7438 12.0547C35.9348 12.0547 35.275 11.3548 35.275 10.4941C35.275 9.63346 35.9348 8.93347 36.7438 8.93347C37.5529 8.93347 38.2127 9.63346 38.2127 10.4941Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.4242 10.6146C35.275 9.69659 36.0553 8.91627 36.9734 9.06545C37.5299 9.15725 37.9774 9.60478 38.0692 10.1613C38.2184 11.0794 37.4381 11.8597 36.5201 11.7105C35.9635 11.6187 35.516 11.1712 35.4242 10.6146Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6709 10.6031C35.5217 9.82854 36.1873 9.16871 36.9619 9.31215C37.3922 9.39248 37.7422 9.74247 37.8225 10.1728C37.9717 10.9474 37.3061 11.6072 36.5316 11.4638C36.1012 11.3834 35.7512 11.0334 35.6709 10.6031Z",
    fill: "url(#paint3_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.211 9.20886C39.9799 11.4293 38.1381 13.4777 35.8832 12.8523C35.2004 12.6687 34.7012 12.158 34.3168 11.567C34.7357 12.1293 35.2635 12.64 35.9348 12.8006C38.1496 13.3514 39.8307 11.3892 39.211 9.20312V9.20886Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8872 16.4268C43.8872 17.2875 43.2274 17.9875 42.4184 17.9875C41.6094 17.9875 40.9495 17.2875 40.9495 16.4268C40.9495 15.5662 41.6094 14.8662 42.4184 14.8662C43.2274 14.8662 43.8872 15.5662 43.8872 16.4268Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.0987 16.5473C40.9495 15.6293 41.7299 14.8489 42.6479 14.9981C43.2044 15.0899 43.652 15.5375 43.7438 16.094C43.8929 17.012 43.1126 17.7924 42.1946 17.6432C41.6381 17.5514 41.1905 17.1038 41.0987 16.5473Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3454 16.5359C41.1963 15.7613 41.8618 15.1014 42.6364 15.2449C43.0667 15.3252 43.4167 15.6752 43.497 16.1055C43.6462 16.8801 42.9807 17.5399 42.2061 17.3965C41.7758 17.3162 41.4258 16.9662 41.3454 16.5359Z",
    fill: "url(#paint4_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1241 18.9973C40.8176 19.4506 39.0504 17.3391 39.9799 15.1933C40.261 14.5449 40.829 14.1203 41.4717 13.822C40.8577 14.1605 40.2782 14.608 40.02 15.2506C39.1651 17.3678 40.875 19.3071 43.1241 18.9973Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2127 22.612C38.2127 23.4727 37.5529 24.1727 36.7438 24.1727C35.9348 24.1727 35.275 23.4727 35.275 22.612C35.275 21.7514 35.9348 21.0514 36.7438 21.0514C37.5529 21.0514 38.2127 21.7514 38.2127 22.612Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.4242 22.7325C35.275 21.8144 36.0553 21.0341 36.9734 21.1833C37.5299 21.2751 37.9774 21.7226 38.0692 22.2792C38.2184 23.1972 37.4381 23.9775 36.5201 23.8284C35.9635 23.7366 35.516 23.289 35.4242 22.7325Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6709 22.7153C35.5217 21.9407 36.1873 21.2809 36.9619 21.4243C37.3922 21.5047 37.7422 21.8547 37.8225 22.285C37.9717 23.0596 37.3061 23.7194 36.5316 23.5759C36.1012 23.4956 35.7512 23.1456 35.6709 22.7153Z",
    fill: "url(#paint5_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7701 20.6497C36.5201 19.0834 39.1192 19.9956 39.4176 22.3136C39.5094 23.0136 39.234 23.6735 38.8381 24.253C39.1938 23.6505 39.4635 22.9677 39.3545 22.285C39.0102 20.0301 36.5545 19.2325 34.7701 20.6497Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9873 25.3087C24.603 21.1948 24.5915 11.3834 32.0677 7.51626C34.3226 6.34005 36.8758 6.48349 39.3143 7.13758C36.8529 6.64988 34.225 6.56382 32.0505 7.76872C24.8555 11.7277 24.8382 20.9825 31.9873 25.3087Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.9807 8.98511C47.6339 12.9785 47.2093 20.8219 42.1831 24.3046C40.6168 25.412 38.8266 26.3587 36.9102 26.3644C38.8037 26.2095 40.5307 25.2169 42.0282 24.0866C46.8364 20.5522 47.2036 13.1621 42.9749 8.99085L42.9807 8.98511Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.2095 52.9699C26.2095 47.4904 30.6505 43.0438 36.1357 43.0438C41.6208 43.0438 46.0618 47.4847 46.0618 52.9699C46.0618 58.4551 41.6208 62.896 36.1357 62.896C30.6505 62.896 26.2095 58.4551 26.2095 52.9699Z",
    fill: "#445B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3858 52.9699C27.3858 48.1388 31.2988 44.2257 36.1299 44.2257C40.961 44.2257 44.8741 48.1388 44.8741 52.9699C44.8741 57.801 40.961 61.714 36.1299 61.714C31.2988 61.714 27.3858 57.801 27.3858 52.9699Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3201 59.2067C39.3201 60.8018 38.0004 62.3854 36.434 62.0927C30.1398 60.9165 33.8291 62.5059 33.548 59.2067C33.4103 57.6174 34.839 56.3207 36.434 56.3207C38.0291 56.3207 39.3201 57.6116 39.3201 59.2067Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8626 52.2182C44.4954 47.8289 40.8807 44.3691 36.4225 44.2372C36.3766 44.2372 36.3365 44.2257 36.2963 44.2257C36.2791 44.2257 36.2676 44.2257 36.2561 44.2257C36.2275 44.2257 36.1988 44.2257 36.1701 44.2257C31.8095 44.2257 28.2464 47.2208 27.5636 51.5469C27.1849 51.983 26.9325 52.5281 26.8694 53.142C26.789 53.9281 27.0358 54.6682 27.4948 55.242C27.6267 56.2002 28.0112 56.6247 29.0669 58.128C28.9349 57.5026 28.8718 56.8485 28.8775 56.1944C29.0612 56.2518 29.2505 56.292 29.4513 56.3092C31.0406 56.4698 32.4521 55.3108 32.6127 53.7272C32.7619 52.2756 31.798 50.9789 30.4152 50.6404C31.2013 49.2519 32.2398 48.0757 33.4218 47.3355C33.5365 48.8273 34.7701 50.0035 36.2906 50.0035C37.8856 50.0035 39.1766 48.7125 39.1766 47.1175C39.1766 47.0831 39.1651 47.0544 39.1651 47.0199C41.093 47.7199 42.6995 49.0798 43.7208 50.824C43.2675 50.5314 42.7339 50.3592 42.1602 50.3592C40.5651 50.3592 39.2741 51.6502 39.2741 53.2453C39.2741 54.8403 40.5651 56.1313 42.1602 56.1313C43.7552 56.1313 45.0462 54.8403 45.0462 53.2453C45.0462 52.8838 44.9716 52.5395 44.8511 52.2182H44.8626Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.4209 43.1298C30.9316 42.3093 25.4694 47.7716 26.2899 54.2608C26.8464 58.6845 30.421 62.2534 34.839 62.8157C41.3282 63.6361 46.7905 58.1739 45.97 51.6846C45.4134 47.2609 41.8389 43.6921 37.4152 43.1298H37.4209ZM39.0733 59.9067C39.1996 59.5165 39.2397 59.0919 39.1651 58.6444C38.993 57.5428 38.1151 56.6305 37.0193 56.4297C35.2004 56.0911 33.6283 57.5657 33.8062 59.3616C33.8349 59.6772 33.9267 59.9755 34.0586 60.2452C34.334 60.8132 33.7545 61.4099 33.1636 61.1919C30.9431 60.3886 29.1357 58.7132 28.1661 56.5788C27.9021 55.9993 28.4587 55.3969 29.0554 55.6149C29.6349 55.8272 30.3005 55.8502 30.9833 55.5862C31.666 55.328 32.2226 54.7772 32.4865 54.0944C33.1922 52.2986 31.9414 50.5486 30.2603 50.3822C29.807 50.3363 29.371 50.4051 28.9808 50.56C28.4013 50.7953 27.7931 50.2502 28.0284 49.6707C28.9521 47.4043 30.7939 45.6199 33.0947 44.765C33.6627 44.5527 34.2422 45.1437 33.9955 45.6945C33.789 46.1478 33.7086 46.6642 33.789 47.2093C33.9496 48.3224 34.8332 49.2519 35.9406 49.4584C37.7594 49.8027 39.3315 48.3224 39.1537 46.5265C39.1364 46.3371 39.0963 46.1478 39.0389 45.9699C38.8496 45.379 39.4864 44.8626 40.043 45.1437C41.8618 46.056 43.3134 47.5765 44.1339 49.4412C44.3864 50.015 43.8184 50.6461 43.2389 50.3994C42.6307 50.1355 41.902 50.0953 41.1676 50.3764C40.4848 50.6404 39.934 51.1912 39.67 51.874C38.9701 53.6641 40.2209 55.4084 41.902 55.5747C43.5028 55.7354 44.8511 54.4961 44.8798 52.9354C44.8798 52.9412 44.8798 52.9469 44.8798 52.9584C44.8798 56.3723 42.9233 59.3214 40.0659 60.7616C39.4922 61.0485 38.884 60.5034 39.0791 59.8952L39.0733 59.9067Z",
    fill: "#4F6B77"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4595 53.1477C31.4595 54.0084 30.7997 54.7084 29.9906 54.7084C29.1816 54.7084 28.5218 54.0084 28.5218 53.1477C28.5218 52.2871 29.1816 51.5871 29.9906 51.5871C30.7997 51.5871 31.4595 52.2871 31.4595 53.1477Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.6653 53.2682C28.5161 52.3502 29.2964 51.5699 30.2144 51.7191C30.771 51.8109 31.2185 52.2584 31.3103 52.815C31.4595 53.733 30.6792 54.5133 29.7611 54.3641C29.2046 54.2723 28.7571 53.8248 28.6653 53.2682Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.912 53.251C28.7628 52.4764 29.4284 51.8166 30.2029 51.96C30.6333 52.0404 30.9833 52.3904 31.0636 52.8207C31.2128 53.5953 30.5472 54.2551 29.7726 54.1117C29.3423 54.0313 28.9923 53.6813 28.912 53.251Z",
    fill: "url(#paint6_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.966 47.0314C37.966 47.892 37.3061 48.592 36.4971 48.592C35.6881 48.592 35.0283 47.892 35.0283 47.0314C35.0283 46.1708 35.6881 45.4708 36.4971 45.4708C37.3061 45.4708 37.966 46.1708 37.966 47.0314Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.1775 47.1519C35.0283 46.2339 35.8086 45.4536 36.7266 45.6027C37.2832 45.6945 37.7307 46.1421 37.8225 46.6986C37.9717 47.6166 37.1914 48.397 36.2734 48.2478C35.7168 48.156 35.2693 47.7085 35.1775 47.1519Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4242 47.1404C35.275 46.3658 35.9406 45.706 36.7152 45.8494C37.1455 45.9298 37.4955 46.2798 37.5758 46.7101C37.725 47.4847 37.0594 48.1445 36.2848 48.0011C35.8545 47.9207 35.5045 47.5707 35.4242 47.1404Z",
    fill: "url(#paint7_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.9643 45.7405C39.7332 47.9609 37.8914 50.0093 35.6365 49.3839C34.9537 49.2003 34.4545 48.6896 34.0701 48.0987C34.489 48.6609 35.0168 49.1716 35.6881 49.3322C37.9028 49.8831 39.584 47.9208 38.9643 45.7347V45.7405Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.6405 52.9641C43.6405 53.8248 42.9807 54.5248 42.1717 54.5248C41.3626 54.5248 40.7028 53.8248 40.7028 52.9641C40.7028 52.1035 41.3626 51.4035 42.1717 51.4035C42.9807 51.4035 43.6405 52.1035 43.6405 52.9641Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.852 53.0846C40.7028 52.1666 41.4831 51.3863 42.4012 51.5355C42.9577 51.6273 43.4052 52.0748 43.4971 52.6314C43.6462 53.5494 42.8659 54.3297 41.9479 54.1805C41.3913 54.0887 40.9438 53.6412 40.852 53.0846Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0987 53.0732C40.9495 52.2986 41.6151 51.6387 42.3897 51.7822C42.82 51.8625 43.17 52.2125 43.2503 52.6428C43.3995 53.4174 42.7339 54.0772 41.9594 53.9338C41.529 53.8535 41.179 53.5035 41.0987 53.0732Z",
    fill: "url(#paint8_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8774 55.5289C40.5709 55.9821 38.8037 53.8707 39.7332 51.7248C40.0086 51.0765 40.5823 50.6519 41.2249 50.3535C40.611 50.692 40.0315 51.1396 39.7733 51.7822C38.9184 53.8994 40.6282 55.8387 42.8774 55.5289Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.966 59.1436C37.966 60.0042 37.3061 60.7042 36.4971 60.7042C35.6881 60.7042 35.0283 60.0042 35.0283 59.1436C35.0283 58.2829 35.6881 57.5829 36.4971 57.5829C37.3061 57.5829 37.966 58.2829 37.966 59.1436Z",
    fill: "#0D1214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.1775 59.2698C35.0283 58.3518 35.8086 57.5715 36.7266 57.7207C37.2832 57.8125 37.7307 58.26 37.8225 58.8166C37.9717 59.7346 37.1914 60.5149 36.2734 60.3657C35.7168 60.2739 35.2693 59.8264 35.1775 59.2698Z",
    fill: "#1E272D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4242 59.2526C35.275 58.478 35.9406 57.8182 36.7152 57.9616C37.1455 58.042 37.4955 58.3919 37.5758 58.8223C37.725 59.5969 37.0594 60.2567 36.2848 60.1132C35.8545 60.0329 35.5045 59.6829 35.4242 59.2526Z",
    fill: "url(#paint9_linear_6_19552)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5234 57.187C36.2734 55.6206 38.8725 56.5329 39.1709 58.8509C39.2627 59.5509 38.9873 60.2108 38.5914 60.7903C38.9471 60.1878 39.2168 59.505 39.1078 58.8222C38.7635 56.5674 36.3078 55.7698 34.5234 57.187Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7406 61.8402C24.3563 57.7264 24.3448 47.915 31.821 44.0478C34.0758 42.8716 36.6291 43.015 39.0676 43.6691C36.6061 43.1814 33.9783 43.0954 31.8037 44.3003C24.6087 48.2592 24.5915 57.5141 31.7406 61.8402Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.7339 45.5167C47.3872 49.5101 46.9626 57.3534 41.9364 60.8362C40.37 61.9435 38.5799 62.8902 36.6635 62.896C38.5569 62.7411 40.284 61.7484 41.7815 60.6181C46.5896 57.0837 46.9568 49.6937 42.7282 45.5224L42.7339 45.5167Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_19552",
    x1: 19.8637,
    y1: 31.4136,
    x2: 19.8637,
    y2: 37.5242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_19552",
    x1: 53.1478,
    y1: -0.0000189126,
    x2: 53.1478,
    y2: -0.0000189126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_19552",
    x1: 30.2374,
    y1: 15.4055,
    x2: 30.2374,
    y2: 17.5973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_19552",
    x1: 36.7496,
    y1: 9.29494,
    x2: 36.7496,
    y2: 11.4867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_19552",
    x1: 42.4184,
    y1: 15.2277,
    x2: 42.4184,
    y2: 17.4195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_19552",
    x1: 36.7496,
    y1: 21.4071,
    x2: 36.7496,
    y2: 23.5989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_19552",
    x1: 28.8948,
    y1: 53.0387,
    x2: 31.0865,
    y2: 53.0387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_19552",
    x1: 35.407,
    y1: 46.9281,
    x2: 37.5988,
    y2: 46.9281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_19552",
    x1: 41.0758,
    y1: 52.8551,
    x2: 43.2675,
    y2: 52.8551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_19552",
    x1: 35.407,
    y1: 59.0403,
    x2: 37.5988,
    y2: 59.0403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8F3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE3B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_19552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 73,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChademoSocket);
export default __webpack_public_path__ + "static/media/chademo_socket.c3c9145fe7fc634ff6ec142e702f5658.svg";
export { ForwardRef as ReactComponent };